import { render } from "./ResultRecommend.vue?vue&type=template&id=7bad5321&scoped=true"
import script from "./ResultRecommend.vue?vue&type=script&lang=js"
export * from "./ResultRecommend.vue?vue&type=script&lang=js"

import "./ResultRecommend.vue?vue&type=style&index=0&id=7bad5321&lang=scss&scoped=true"

import exportComponent from "/Users/konatsu/docker-static/speedo.devs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bad5321"]])

export default __exports__